import {
  FETCH_ACCOUNT_EXTENDED_PROPERTY_INIT,
  FETCH_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
  FETCH_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
  FETCH_ACCOUNT_EXTENDED_PROPERTY_NO_LOADING_INIT,
  FETCH_ACCOUNT_EXTENDED_PROPERTY_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_EXTENDED_PROPERTY_NO_LOADING_FAILURE,
  SAVE_ACCOUNT_EXTENDED_PROPERTY_INIT,
  SAVE_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
  SAVE_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
  UPDATE_ACCOUNT_EXTENDED_PROPERTY_INIT,
  UPDATE_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
  UPDATE_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
  DELETE_ACCOUNT_EXTENDED_PROPERTY_INIT,
  DELETE_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
  DELETE_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
  ACCOUNT_EXTENDED_PROPERTY_RESET_MODAL,
  RESET_ACCOUNT_EXTENDED_PROPERTY
} from './types';
import API from './api';

/* Actions Creators */

export function resetModalExtendedProperty() {
  return {
    type: ACCOUNT_EXTENDED_PROPERTY_RESET_MODAL
  };
}

export function resetAccountExtendedProperty() {
  return {
    type: RESET_ACCOUNT_EXTENDED_PROPERTY
  };
}

/* Account ExtendedProperty */

function fetchApiSuccess(data) {
  return {
    type: FETCH_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_ACCOUNT_EXTENDED_PROPERTY_INIT
  };
}

export function fetchAccountExtendedPropertyApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Account ExtendedProperty no loading */

function fetchApiNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_ACCOUNT_EXTENDED_PROPERTY_NO_LOADING_SUCCESS,
    payload: data,
    concat: concat
  };
}

function fetchApiNoLoadingFailure(error) {
  console.log(error);
  return {
    type: FETCH_ACCOUNT_EXTENDED_PROPERTY_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_ACCOUNT_EXTENDED_PROPERTY_NO_LOADING_INIT
  };
}

export function fetchAccountExtendedPropertyNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* ExtendedProperty Save (Async) */

function saveApiSuccess(data) {
  return {
    type: SAVE_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
    payload: data
  };
}

function saveApiFailure(error) {
  return {
    type: SAVE_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
    errorSave: error
  };
}

function saveApiInit() {
  return {
    type: SAVE_ACCOUNT_EXTENDED_PROPERTY_INIT
  };
}

export function handleExtendedProperty(data) {
  return async dispatch => {
    dispatch(saveApiInit());
    try {
      const resp = await API.data.handleExtendedProperty(data);
      return dispatch(saveApiSuccess(resp));
    } catch (error) {
      return dispatch(saveApiFailure(error));
    }
  };
}

/* ExtendedProperty Update (Async) */

function updateApiSuccess(data) {
  return {
    type: UPDATE_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
    payload: data
  };
}

function updateApiFailure(error) {
  return {
    type: UPDATE_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
    errorupdate: error
  };
}

function updateApiInit() {
  return {
    type: UPDATE_ACCOUNT_EXTENDED_PROPERTY_INIT
  };
}

export function handleUpdateExtendedProperty(data) {
  return async dispatch => {
    dispatch(updateApiInit());
    try {
      const resp = await API.data.handleUpdateExtendedProperty(data);
      return dispatch(updateApiSuccess(resp));
    } catch (error) {
      return dispatch(updateApiFailure(error));
    }
  };
}

/* ExtendedProperty Delete (Async) */

function deleteApiSuccess(data) {
  return {
    type: DELETE_ACCOUNT_EXTENDED_PROPERTY_SUCCESS,
    payload: data
  };
}

function deleteApiFailure(error) {
  return {
    type: DELETE_ACCOUNT_EXTENDED_PROPERTY_FAILURE,
    errordelete: error
  };
}

function deleteApiInit() {
  return {
    type: DELETE_ACCOUNT_EXTENDED_PROPERTY_INIT
  };
}

export function handleDeleteExtendedProperty(data) {
  return async dispatch => {
    dispatch(deleteApiInit());
    try {
      const resp = await API.data.handleDeleteExtendedProperty(data);
      return dispatch(deleteApiSuccess(resp));
    } catch (error) {
      return dispatch(deleteApiFailure(error));
    }
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/account_extended_property/index.js